import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { deleteMapping } from "./service";
import { MdaExtractMappingDetail } from "./types";

const MappingDeleteDialog = ({
  selectedMapping,
  open,
  onClose,
}: {
  selectedMapping: MdaExtractMappingDetail;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          `Are you sure you want to delete the mapping for "${selectedMapping.sourceColumn}"? This cannot be undone.`,
          {
            title: "Confirm Mapping Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteMapping(selectedMapping.id);
            showNotification({
              message: "Column mapping deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete column mapping. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [open, confirm, selectedMapping, showNotification, onClose]);

  return null;
};

export default MappingDeleteDialog;
